import React, { useState } from "react";
import { Eyebrow, Title } from "../components/CommonComponents";
import administrationHero from "../assets/img/about/university-administration.png";

import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

const authorities = [
    ["Hon'ble Visitor", "Hon'ble Shri Raman Deka", "Hon’ble Shri Raman Deka Ji serving as the Governor of Chhattisgarh, bringing with him a wealth of experience and dedication to public service.", "/honorable-visitor"],
    ["Hon'ble Patron", "Shri Mahesh Agarwal", "ISBM University was established in the year 2016 with an objective to cater the multifaceted educational needs of the millions.", "/honorable-patron"],
    ["Hon'ble Chancellor", "Dr. Vinay M. Agrawal", "Education is an intervention in the modern society where, harmanious development can be achieved by enlightenment of an individual's heart, mind and soul.", "/honorable-chancellor"],
    ["Hon'ble Vice Chancellor", "Prof. (Dr.) Anand Mahalwar", "It gives me great pleasure in extending my hearty welcome to all who are seeking admission to various Programmes of ISBM University.", "/honorable-vice-chancellor"],
    ["Registrar", "Dr. Barada Prasad Bhol", "Registrar, ISBM University and Member Secretary of the University's principal statutory academic and governance bodies.", "/registrar"],
];

const governance = [
    ["01", "Governing Body", "Principal decision-making body responsible for strategic plans, resources and institutional development.", "/governing-body"],
    ["02", "Board of Management", "Statutory management body dealing with administration, appointments, resources and operational decisions.", "/board-management"],
    ["03", "Academic Council", "Academic body coordinating and supervising the University's academic policies and programmes.", "/academic-council"],
    ["04", "Other Committees", "Committees supporting student welfare, compliance, grievance redressal and institutional responsibilities.", "/other-committees"],
];


export default function UniversityAdministration() {

    return (
        <>
            <MetaInfo param="" id="about" />

            <Header school="common" />
            <main className="overflow-hidden bg-white">
                <section className="relative isolate min-h-[70vh] overflow-hidden bg-navy text-white">
                    <img src={administrationHero} alt="ISBM University administration" className="absolute inset-0 -z-30 h-full w-full object-cover" />
                    <div className="absolute inset-0 -z-20 bg-[linear-gradient(90deg,rgba(7,26,47,0.98)_0%,rgba(7,26,47,0.91)_45%,rgba(7,26,47,0.42)_76%,rgba(7,26,47,0.18)_100%)]" />
                    <div className="mx-auto flex min-h-[70vh] w-[min(1380px,calc(100%-48px))] items-end pb-24 pt-[190px] max-sm:w-[calc(100%-28px)]">
                        <div className="max-w-[920px]">
                            <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                <span className="h-px w-12 bg-current" />
                                Leadership, governance and stewardship
                            </div>

                            <h1 className="mt-7 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(50px,6.5vw,92px)] font-normal leading-[0.96] tracking-[-0.045em]">
                                Institutional Excellence
                                <span className="block text-[#D5AD57]">
                                    Responsible Leadership
                                </span>
                            </h1>
                            <p className="mt-8 max-w-[720px] text-[17px] leading-8 text-white/70">Explore the leadership and statutory governance structure supporting the academic, administrative and institutional responsibilities of ISBM University.</p>
                        </div>
                    </div>
                </section>

                <section className="bg-white py-20 sm:py-24 lg:py-28">
                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
                        <Eyebrow>University Authorities</Eyebrow>
                        <Title before="Leadership That" after="University Forward" highlight="Guides The" position="middle" theme="burgundy" />
                        <div className="mt-12">
                            {authorities.map(([role, name, description, href], i) => (
                                <a target="_blank" key={role} href={href} className="group grid gap-5 border-b border-navy/10 py-8 sm:grid-cols-[60px_190px_.8fr_1.2fr_48px] sm:items-center">
                                    <span className="font-serif text-[26px] text-gold-dark">{String(i + 1).padStart(2, "0")}</span>
                                    <span className="text-xs font-bold uppercase tracking-[.12em] text-burgundy">{role}</span>
                                    <h3 className="font-serif text-[26px] font-normal text-navy group-hover:text-burgundy">{name}</h3>
                                    <p className="text-sm leading-7 text-ink/55">{description}</p>
                                    <span className="grid h-11 w-11 place-items-center rounded-full border border-navy/15 text-burgundy">↗</span>
                                </a>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="bg-[#EEF4F8] py-20 lg:py-28">
                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
                        <Eyebrow>Governance Framework</Eyebrow>
                        <Title before="Four Routes To" highlight="Responsible Governance" after="" position="middle" theme="burgundy" />
                        <div className="mt-14 border-t border-navy/15">
                            {governance.map(([n, title, text, href]) => <a target="_blank" key={n} href={href} className="group grid gap-5 border-b border-navy/15 py-8 md:grid-cols-[90px_.75fr_1.25fr_50px] md:items-center">
                                <span className="font-serif text-[40px] text-burgundy/30">{n}</span>
                                <h3 className="font-serif text-[30px] font-normal text-navy group-hover:text-burgundy">{title}</h3>
                                <p className="max-w-[600px] text-[15px] leading-7 text-ink/60">{text}</p>
                                <span className="text-xl text-burgundy">↗</span>
                            </a>)}
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}
